//search logic
//https://codesandbox.io/s/react-table-global-fuzzy-text-search-2y55j2?file=/src/App.js:1460-1569
import {clearHTML, clearNBSP, updatePTextById} from "../../Utils/helpers";
import {createAnnotation} from "../../API/annotatorApi";
//import {updateProjectStatus} from "../../API/analysenrequestdata";
import copy from 'text-copy';
import React, {
    useEffect, useMemo, memo, useState
} from "react";
import $ from 'jquery';
import {useTable, useGlobalFilter, usePagination, useSortBy} from "react-table";
import {Table} from "react-bootstrap";

function AdvicesTable(props) {
    let [parsedlv_id] = useState(props.lvid)

    const colors = {
        Potenzial: 'rgb(5, 165, 107)',
        Risiko: 'rgb(239, 3, 3)',
        Hinweis: 'rgb(231, 185, 20)',
        default: 'rgb(82, 125, 219)'
    }
    let data = useMemo(() => props.data, [props.data]);
    let columns = useMemo(() => props.columns, [props.columns]);


    const globalFilter = React.useCallback((rows, ids, query) => {
        const searchTerm = String(query).toLowerCase();
        return rows.filter((row) => {
            const matches = ids.filter((id) => {
                const rowValue = row.values[id];
                return rowValue !== undefined
                    ? String(rowValue).toLowerCase().includes(searchTerm)
                    : false;
            });

            return matches.length > 0;
        });
    }, []);


    // Use the useTable Hook to send the columns and data to build the table
    let {
        getTableProps, // table props from react-table
        getTableBodyProps, // table body props from react-table
        headerGroups, // headerGroups, if your table has groupings
        //rows, // rows for the table based on the data passed
        prepareRow, // Prepare the row (this function needs to be called for each row before getting the row props)
        setGlobalFilter,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: {pageIndex, pageSize}

    } = useTable({
            columns,
            data,
            globalFilter
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );


    const handleFilterInputChange = (e) => {
        setGlobalFilter(e.currentTarget.value);
    };


    const handleNewAnnotation = async (lvID, ID, rowID, annotation, positionText) => {
        // eslint-disable-next-line no-useless-catch
        if (lvID === "None") {
            lvID = rowID.split("=")[0]
        }
        let serverResponse = await createAnnotation(lvID, ID, rowID, annotation, positionText)
        console.log(serverResponse)
        if (serverResponse.status === 200) {
            //await updateProjectStatus({"uploadlv_id": lvID, "status": "in-progress"})
            console.log("Successfully created new annotation")
            return true
        } else {
            return false
        }
    }

    const updateUIState = (rowID, selectedAnnotationID, annotation, positionText) => {
        let state = props.annotationData
        let updatedDocument = updatePTextById(state.lv_document, rowID, positionText);
        let exists = state.annotations.some((obj) => obj.unique_id === selectedAnnotationID);
        if (exists) {
            let newState = state.annotations.filter((obj) => obj.unique_id !== selectedAnnotationID);
            newState.push(annotation)
            let update = {annotations: newState, lv_document: updatedDocument}
            props.setAnnotationData(update)
        } else {
            state.annotations.push(annotation)
            let update = {annotations: state.annotations, lv_document: updatedDocument}
            props.setAnnotationData(update)
        }
    }

    const populateAnnotationUI = async (annotation) => {
        let kommentor = clearHTML(annotation.kommentor);
        let norm = clearHTML(annotation.norm);
        let advice = clearHTML(annotation.advice);
        let formula = clearHTML(annotation.formula);

        //Clear nbsp - No-Break SPace
        kommentor = clearNBSP(kommentor);
        norm = clearNBSP(norm);
        advice = clearNBSP(advice);
        formula = clearNBSP(formula);

        // Populating the Annotator form Component
        $('#norm').val(norm);
        $('#advice').val(advice);
        $('#agl').val(annotation.law);
        $('#kommentor').val(kommentor);
        $('#category').val(annotation.type);
        $('#formel').val(formula);
        $('#ursache').val(annotation.Annotation);
    }

    const traverseColor = async (annotation) => {
        let annotationMark = document.getElementById(annotation.unique_id)
        annotationMark.style.backgroundColor = colors[annotation.type];
        $('mark').removeClass('dashed-border-mark');
        annotationMark.classList.remove('entity');
    }



        async function getCurrentPositionText(rowID) {
            return document.getElementById(rowID).innerHTML
        }

        const copyAdvice = async (row) => {
            let selectedAnnotationID = localStorage.getItem("annotationID")
            //let annotationData = props.annotationData.annotations
            //let annotation = await getAnnotationsDB(selectedAnnotationID)
            let annotations = props.annotationData.annotations
            let annotation = annotations.find((obj) => obj.unique_id === selectedAnnotationID);
            annotation.adviceID = row.uidid
            annotation.law = row.anspruch;
            annotation.kommentor = row.kommentor;
            annotation.norm = row.norm;
            annotation.advice = row.advice;
            annotation.formula = row.formel;
            annotation.adviceID = row.uidid;
            annotation.type = row.category;
            annotation.value = '0';
            await populateAnnotationUI(annotation)
            await traverseColor(annotation)
            let rowID = annotation.rowId
            let lvID = parsedlv_id
            //let lvID = localStorage.getItem("parsedlv_id");
            let positionText = await getCurrentPositionText(rowID)

            let isCreated = await handleNewAnnotation(lvID,
                selectedAnnotationID,
                rowID,
                annotation,
                positionText
            )
            console.log(isCreated)

            //setAnnotationDB(annotation)
            props.handleClose()
            if (isCreated) {
                updateUIState(rowID, selectedAnnotationID, annotation, positionText)
            } else {
                alert("Annotation failed to create")
            }
        }


        useEffect(async () => {


        }, [])
        /*
          Render the UI for your table
          - react-table doesn't have UI, it's headless. We just need to put the react-table props from the Hooks, and it will do its magic automatically
        */
        return (
            <>
                <input
                    name="search"
                    placeholder="Search"
                    onChange={handleFilterInputChange}
                />
                <Table {...getTableProps()}>
                    <thead>
                    {headerGroups.map(headerGroup => (
                        // eslint-disable-next-line react/jsx-key
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                // eslint-disable-next-line react/jsx-key
                                <th {...column.getHeaderProps(column.getSortByToggleProps())}>{column.render("Header")}
                                    <span>
                            {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                        </span>
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                    {page.map((row, i) => {
                        prepareRow(row);
                        return (
                            // eslint-disable-next-line react/jsx-key
                            <tr
                                className="advicesTDTextFormat"
                                onClick={() => {
                                    console.log(i)
                                    copyAdvice(row.original)
                                }
                                }
                                onContextMenu={() => {
                                    let isCopied = copy(row.original.uidid);
                                    if (isCopied) {
                                        alert('Advice ID ' + row.original.uidid + ' is copied');
                                        props.handleClose();
                                    }
                                    document.addEventListener('contextmenu', (event) => event.preventDefault());
                                }}
                                {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                    // eslint-disable-next-line react/jsx-key
                                    return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                                })}
                            </tr>
                        );
                    })}
                    </tbody>
                </Table>

                <div className="pagination">
                    <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                        {"<<"}
                    </button>
                    {" "}
                    <button onClick={() => previousPage()} disabled={!canPreviousPage}>
                        {"<"}
                    </button>
                    {" "}
                    <button onClick={() => nextPage()} disabled={!canNextPage}>
                        {">"}
                    </button>
                    {" "}
                    <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                        {">>"}
                    </button>
                    {" "}
                    <span>&emsp;
                        Page{" "}
                        <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{" "}
        </span>
                    <span>&emsp;
                        | Go to page:{" "}
                        <input
                            type="number"
                            defaultValue={pageIndex + 1}
                            onChange={(e) => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                gotoPage(page);
                            }}
                            style={{width: "100px"}}
                        />
        </span>{" "}
                    <select
                        value={pageSize}
                        onChange={(e) => {
                            setPageSize(Number(e.target.value));
                        }}
                    >
                        {[5, 20, 30, 40, 50].map((pageSize) => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                            </option>
                        ))}
                    </select>
                    <div>&emsp;&emsp;&emsp;&emsp;<span>{data.length} entries</span></div>
                </div>

            </>


        );
    }

    export default memo(AdvicesTable);


